import React, { useState, useEffect } from 'react';
import './SearchResults.css';

const SearchResults = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (searchQuery.trim()) {
      performSearch();
    } else {
      setResults([]);
    }
  }, [searchQuery]);

  const performSearch = async () => {
    setLoading(true);
    
    try {
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      const mockResults = [
        {
          id: 1,
          documentName: 'Q4_Earnings_Report_2023.pdf',
          excerpt: 'The company reported strong quarterly earnings with revenue growth of 15% compared to the previous quarter.',
          relevance: 0.95,
          page: 12,
          tags: ['earnings', 'revenue', 'growth']
        },
        {
          id: 2,
          documentName: 'Annual_Report_2023.docx',
          excerpt: 'Financial highlights show consistent performance across all business segments.',
          relevance: 0.87,
          page: 8,
          tags: ['financial', 'cash flow', 'debt']
        }
      ];
      
      setResults(mockResults);
    } catch (error) {
      console.error('Search failed:', error);
      setResults([]);
    } finally {
      setLoading(false);
    }
  };

  const getRelevanceColor = (relevance) => {
    if (relevance >= 0.9) return '#10b981';
    if (relevance >= 0.7) return '#f59e0b';
    return '#ef4444';
  };

  return (
    <div className="search-results">
      <div className="search-header">
        <h3>Document Search</h3>
        <input
          type="text"
          placeholder="Search in documents..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="search-input"
        />
      </div>

      <div className="results-container">
        {loading ? (
          <div className="loading-results">
            <div className="loading-spinner">⏳</div>
            <p>Searching documents...</p>
          </div>
        ) : searchQuery.trim() && results.length === 0 ? (
          <div className="no-results">
            <p>No results found for "{searchQuery}"</p>
          </div>
        ) : searchQuery.trim() ? (
          <div className="results-list">
            <div className="results-count">
              Found {results.length} result{results.length !== 1 ? 's' : ''}
            </div>
            {results.map((result) => (
              <div key={result.id} className="result-item">
                <div className="result-header">
                  <h4 className="result-title">{result.documentName}</h4>
                  <div className="result-meta">
                    <span className="relevance-score" style={{ color: getRelevanceColor(result.relevance) }}>
                      {Math.round(result.relevance * 100)}% relevant
                    </span>
                    <span className="page-number">Page {result.page}</span>
                  </div>
                </div>
                
                <p className="result-excerpt">{result.excerpt}</p>
                
                <div className="result-tags">
                  {result.tags.map((tag, index) => (
                    <span key={index} className="result-tag">{tag}</span>
                  ))}
                </div>
                
                <div className="result-actions">
                  <button className="view-result-btn">View Document</button>
                  <button className="copy-excerpt-btn">Copy Excerpt</button>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="search-placeholder">
            <div className="search-icon">🔍</div>
            <p>Enter a search term to find relevant documents</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchResults; 